import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearch } from '@components/reducers/search';
import TableContainer from '@mui/material/TableContainer';
import { CustomerOrderTotalPrice, FormatDate } from '@components/Shared/Utils';
import { DisplayPrice } from '@components/Shared/Utils/price';
import { GetAccountSettings, GetCommonSettings } from '@themes/common/data';
import useCustomerReducer from '../useCustomerReducer';
import { AccountPaperContainer } from '../components';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, } from '@mui/x-data-grid';
import { CleanupFilterItems } from '@commons/filters/frontend';
import { parseISO } from 'date-fns';
import { Typography } from '@mui/material';
const { customers_order_amount_with_vat, customers_offers_order_number, customers_offers_date, customers_offers_marking, customers_offers_reference, customers_offers_status, customers_order_ordered, customers_order_not_ordered, } = GetAccountSettings().translations;
const Offers = (_) => {
    const location = useLocation();
    const navigate = useNavigate();
    const settings = GetCommonSettings();
    const [{ customer }] = useCustomerReducer();
    const [sort, setSort] = useState([]);
    const [filters, setFilters] = useState({
        items: [],
    });
    const params = useMemo(() => {
        return { customerId: customer === null || customer === void 0 ? void 0 : customer.id };
    }, [customer === null || customer === void 0 ? void 0 : customer.id]);
    const [state, { setPageAndLimit, setExtraFilters }] = useSearch(`${process.env.HOST}/api/offers`, 'customer_quotes', params);
    const pagination = useMemo(() => ({
        page: state.filters.page - 1,
        pageSize: state.filters.limit,
    }), [state.filters.limit, state.filters.page]);
    const handlePaginationModelChange = useCallback((e) => {
        setPageAndLimit(e.page + 1, e.pageSize);
    }, [setPageAndLimit]);
    const handleRowClick = useCallback((params) => {
        navigate(`${location.pathname}?id=${params.row.id}`);
    }, [location.pathname, navigate]);
    const columns = useMemo(() => [
        {
            field: 'orderNumber',
            headerName: customers_offers_order_number,
            width: 150,
        },
        {
            field: 'quoteDate',
            headerName: customers_offers_date,
            type: 'date',
            renderCell: (params) => FormatDate(params.row.quoteDate, 'yyyy-MM-dd'),
            width: 120,
            valueGetter: (params) => params.row.quoteDate ? parseISO(params.row.quoteDate.toString()) : null,
        },
        {
            field: 'businessContactOrderNumber',
            headerName: customers_offers_marking,
            width: 200,
        },
        {
            field: 'businessContactReference.name',
            headerName: customers_offers_reference,
            renderCell: (params) => { var _a; return (_a = params.row.businessContactReference) === null || _a === void 0 ? void 0 : _a.name; },
            width: 200,
            valueGetter: (params) => { var _a; return (_a = params.row.businessContactReference) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            field: 'status',
            headerName: customers_offers_status,
            type: 'boolean',
            valueGetter: (params) => { var _a, _b; return ((_b = (_a = params.row.shopifyDraftOrder) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString()) === 'COMPLETED'; },
            renderCell: (params) => {
                var _a, _b;
                const completed = ((_b = (_a = params.row.shopifyDraftOrder) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString()) === 'COMPLETED';
                return (_jsx(Typography, Object.assign({ sx: { color: completed ? '#2ecc71' : '#e74c3c' } }, { children: completed ? customers_order_ordered : customers_order_not_ordered })));
            },
            width: 150,
            filterable: false,
            sortable: false,
        },
        {
            field: 'totalPrice',
            headerName: customers_order_amount_with_vat,
            valueGetter: (params) => CustomerOrderTotalPrice(params.row),
            renderCell: (params) => params.row.draftOrder ? DisplayPrice(params.row.draftOrder.totalPrice) : DisplayPrice(CustomerOrderTotalPrice(params.row)),
            width: 150,
            filterable: false,
            sortable: false,
        },
        {
            field: 'id',
            headerName: '',
            width: 50,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (_jsx(ChevronRightIcon, { sx: { cursor: 'pointer' }, onClick: () => {
                    navigate(`${location.pathname}?id=${params.row.id}`);
                } })),
        },
    ], [location.pathname, navigate]);
    useEffect(() => {
        setExtraFilters({
            sort,
            filters: CleanupFilterItems(filters, {
                date: ['quoteDate'],
                string: ['orderNumber', 'businessContactOrderNumber', 'businessContactReference.name'],
            }),
        });
    }, [filters, setExtraFilters, sort]);
    return (_jsx(TableContainer, Object.assign({ component: AccountPaperContainer }, { children: _jsx(DataGrid, { columns: columns, rows: state.items, initialState: {
                pagination: {
                    paginationModel: { page: 0, pageSize: 25 },
                },
            }, pageSizeOptions: [10, 25, 50, 100, 250], sortModel: sort, filterModel: filters, onSortModelChange: setSort, onFilterModelChange: setFilters, onRowClick: handleRowClick, paginationModel: pagination, onPaginationModelChange: handlePaginationModelChange, loading: state.loading }) })));
};
export default Offers;
